
import DocumentExportList from './document-export-list'

export default {
  box: DocumentExportList,
}
